import { Directive, inject, Input, ViewContainerRef } from '@angular/core';
import { Media, VimeoMedia } from '@madeinlune/drupal-types';
import { from, take } from 'rxjs';
import { VimeoPlayerData } from '@nx-massaud/media/ui/vimeo';
import { Options } from '@vimeo/player';

export interface MediaConfig {
  [id: string]: {
    component: () => Promise<any>;
  };
}

const mediaConfig: MediaConfig = {
  images: {
    component: () =>
      import('@nx-massaud/media/ui/image').then((m) => m.MediaImageComponent),
  },
  'media--vimeo': {
    component: () =>
      import('@nx-massaud/media/ui/vimeo').then((m) => m.MediaVimeoComponent),
  },
};

@Directive({
  selector: '[nxMassaudMediaSwitcher]',
  standalone: true,
})
export class MediaSwitcherDirective {
  private viewContainer = inject(ViewContainerRef);

  @Input('nxMassaudMediaSwitcher') media!: Media;

  @Input('nxMassaudMediaSwitcherOptions') options!: Options;

  @Input('nxMassaudMediaSwitcherClasses') classes!: string[] | undefined;

  constructor() {}

  notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
  }
  ngOnInit(): void {
    if (mediaConfig[this.media.type]) {
      from(mediaConfig[this.media.type].component())
        .pipe(take(1))
        .subscribe((component) => {
          this.viewContainer.clear();
          if (component) {
            const componentRef =
              this.viewContainer.createComponent<any>(component);
            if (this.classes) {
              const cleanedClasses = this.classes
                .map((c) => c.split('item-').pop())
                .filter(this.notEmpty);
              (
                componentRef.location.nativeElement as HTMLElement
              ).classList.add(...cleanedClasses);
            }
            if (this.media.type === 'images') {
              componentRef.setInput('image', this.media);
              componentRef.setInput('forceHeight', true);
            } else if (this.media.type === 'media--vimeo') {
              const vimeoPlayerData: VimeoPlayerData = {
                media: this.media as VimeoMedia,
                options: this.options,
              };
              componentRef.setInput('video', vimeoPlayerData);
            }
            componentRef.changeDetectorRef.detectChanges();
          }
        });
    }
  }
}
